import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BasicInfoSection = ({ analysisData, getStatusColor, formatDate }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            width: '100%',
            height: '250px',
            borderRadius: '12px',
            overflow: 'hidden',
            background: '#f5f5f7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={analysisData.imageUrl}
            alt={analysisData.mealName || t('unnamedMeal')}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <Box
            sx={{
              display: 'none',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666',
            }}
          >
            <Typography variant="body2">{t('imageNotAvailable')}</Typography>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
            {analysisData.mealName || t('unnamedMeal')}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: getStatusColor(analysisData.status),
              }}
            />
            <Typography variant="body2" sx={{ color: getStatusColor(analysisData.status), fontWeight: 500 }}>
              {t(`foodAnalysisObj.${analysisData.status}`)}
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ color: '#666' }}>
            {t('analyzedOn')} {formatDate(analysisData.uploadDate)}
          </Typography>

          <Typography variant="body2" sx={{ color: '#666' }}>
            {t('provider')}: {analysisData.analysisProvider}
          </Typography>

          {analysisData.fileName && (
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('file')}: {analysisData.fileName}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default BasicInfoSection;
